<template>
  <div class="cp-backoffice-breadcrumbs mr-breadcrumbs-box" v-if="$breadcrumbs.length">
    <template v-for="(breadcrumb, idx) in $breadcrumbs">
      <component
        v-if="breadcrumb.template"
        :key="idx"
        :is="breadcrumb.template"
        :breadcrumb="breadcrumb"
        class="cp-backoffice-breadcrumbs-item"
      />
      <router-link
        class="cp-backoffice-breadcrumbs-item  is-size-6"
        v-else
        :key="idx"
        :to="{ name: breadcrumb.name, params: breadcrumb.params, query: breadcrumb.query }"
        >{{ $t(breadcrumb.label) }}</router-link
      >
    </template>
  </div>
</template>

<script>
export default {
  name: 'BreadCrumbs',
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.cp-backoffice-breadcrumbs {
  background-color: white;
  border : grey solid 1px;
  // margin : 10px 70px 30px 30px;
  border-radius: 5px;
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 20px;
  padding-right: 50rem;
  display: flex;
  margin-top:20px;
  margin-bottom: 20px;
  width: 100%;

  a {
    color: $grey;
    font-weight: bold;
    font-size: 20px !important;
  }

  &-item + &-item::before {
    color: #FFB900;
    margin-left: 5px;
    margin-right: 5px;
    content: '>';
  }
}
</style>
